var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.5C5 3.3585 8.3585 0 12.5 0C14.2486 0 15.8576 0.598681 17.1331 1.60221L14.9866 3.74871C14.2742 3.27561 13.4193 3 12.5 3C10.0145 3 8 5.0145 8 7.5C8 9.9855 10.0145 12 12.5 12C14.9855 12 17 9.9855 17 7.5C17 7.42311 16.9981 7.34667 16.9943 7.27072L19.4895 4.77528C19.8191 5.61988 20 6.53886 20 7.5C20 15 12.5 24 12.5 24C12.5 24 5 15 5 7.5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3508 10.2713L9.05078 6.97131L9.99345 6.02864L12.3518 8.38431L12.3508 8.38531L18.7362 2L19.6789 2.94267L13.2935 9.32864L12.3508 10.2713Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalization);
export default __webpack_public_path__ + "static/media/localization.172b03efda281321d2746c4eb32584a5.svg";
export { ForwardRef as ReactComponent };